import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { showNotification } from '@spark/ui-components/components/Notification'; // Hook personalizado para notificações com integração de tema

export const useNotification = () => {
  const theme = useContext(ThemeContext); // Configuração padrão do tema para notificações

  const defaultTheme = {
    className: theme?.mode || 'light'
  };
  const defaultRtl = {
    direction: theme?.direction || 'ltr'
  };
  const notification = {
    success: (message, title = 'Sucesso') => {
      showNotification(defaultTheme, defaultRtl, title, message, 'success');
    },
    error: (message, title = 'Erro') => {
      showNotification(defaultTheme, defaultRtl, title, message, 'danger');
    },
    warning: (message, title = 'Aviso') => {
      showNotification(defaultTheme, defaultRtl, title, message, 'warning');
    },
    info: (message, title = 'Informação') => {
      showNotification(defaultTheme, defaultRtl, title, message, 'primary');
    },
    // Método para notificações customizadas
    custom: (message, title, type = 'primary', customTheme = null, customRtl = null) => {
      const finalTheme = customTheme || defaultTheme;
      const finalRtl = customRtl || defaultRtl;
      showNotification(finalTheme, finalRtl, title, message, type);
    }
  };
  return notification;
};
